import { Route, Routes as Switch } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { Toaster } from "react-hot-toast";
import CommonProvider from "context/CommonProvider";
import Dashboard from "routes/container/Routes";
import Login from "pages/login/container";
import { LightTheme } from "styles/theme/lightTheme";
import { muiTheme } from "styles/theme/muiTheme";
import "styles/index.scss";
import { Suspense } from "react";
import Loader from "pages/loader/container/Loader";

import "react-quill/dist/quill.snow.css";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// ✅ Redux
import { Provider } from "react-redux";
import { store } from "store/store";

function App() {
  return (
    <Provider store={store}>
      <CommonProvider>
        <MuiThemeProvider theme={muiTheme}>
          <ThemeProvider theme={LightTheme}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Suspense fallback={<Loader fullWidth />}>
              <Switch>
                <Route path="*" element={<Dashboard />} />
                <Route path="/login" element={<Login />} />
              </Switch>
            </Suspense>
            </LocalizationProvider>
          </ThemeProvider>
        </MuiThemeProvider>
        <Toaster containerStyle={{ zIndex: "100000" }} />
      </CommonProvider>
    </Provider>
  );
}

export default App;
